import React from "react";
import Button, { ButtonProps } from "web/react/components/button/button";
import classnames from "classnames";
import styles from "./multiply-on-hover-button.css";

type MultiplyOnHoverButtonProps = Pick<
    ButtonProps,
    | "className"
    | "href"
    | "onClick"
    | "disabled"
    | "fullWidth"
    | "fullHeight"
    | "openInNewTab"
    | "children"
>;

export default function MultiplyOnHoverButton({
    className,
    href,
    onClick,
    disabled,
    fullWidth,
    fullHeight,
    openInNewTab,
    children,
}: MultiplyOnHoverButtonProps): JSX.Element {
    return (
        <Button
            href={href}
            styleType="cta"
            className={classnames(className, styles.buttonMultiply, {
                [styles.disabled]: disabled,
            })}
            onClick={onClick}
            disabled={disabled}
            fullWidth={fullWidth}
            fullHeight={fullHeight}
            openInNewTab={openInNewTab}
        >
            <div className={classnames(styles.multiplyLabel, styles.topLabel)}>{children}</div>
            <div className={classnames(styles.multiplyLabel, styles.bottomLabel)}>{children}</div>
            <div className={classnames(styles.multiplyLabel, styles.centerLabel)}>{children}</div>
        </Button>
    );
}
